import {Component, Output, EventEmitter, Input, AfterViewInit, ChangeDetectionStrategy} from '@angular/core';
import CompanyEventToolbarAction from "../../../enums/company-event-toolbar-action";
@Component({
    selector: 'company-events-toolbar',
    templateUrl: './company-events-toolbar.component.html',
    styleUrls: ['./company-events-toolbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsToolbarComponent implements AfterViewInit{

  @Output() onClickAction = new EventEmitter();
  @Input() userCanEdit:boolean = false;
  @Input() userCanCreate:boolean = false;
  @Input() userOnCalendar:boolean = false;
  @Output() onEditToggle = new EventEmitter();
  isEditMode:boolean = false;

  toolBarElements: any[] = [
    {
      name: "Back to Company Events Calendar",
      icon: "calendar_month",
      class: "calendar-view-btn",
      onClickAction: () => {
        this.onClickAction.emit(CompanyEventToolbarAction.Return)
      }
    },
    {
      name: "Add new event",
      icon: "edit_calendar",
      class: "add-new-event-btn",
      onClickAction: () => {
        this.onClickAction.emit(CompanyEventToolbarAction.Add)
      }
    },
    // {
    //   name: "Add to Outlook Calendar", //Remove from calendar
    //   icon: "mail_outline", //delete
    //   class: "outlook-event-btn",
    //   onClickAction: () => {
    //     this.onClickAction.emit(CompanyEventToolbarAction.Outlook)
    //   }
    // },
  ]

  ngAfterViewInit(){
    // setTimeout(() => {
    //   this.toolBarElements = this.toolBarElements.map((item:any) => {
    //     if(item.class=="outlook-event-btn" && this.userOnCalendar){
    //       return {name: "Remove from Outlook Calendar", icon: "delete", class: "outlook-event-btn", onClickAction: () => {this.onClickAction.emit(CompanyEventToolbarAction.Outlook)}}
    //     }
    //     return item;
    //   })
    // }, 2000)
  }


  editToggle(){
    this.isEditMode = !this.isEditMode;
    this.onEditToggle.emit()
  }

  protected readonly CompanyEventToolbarAction = CompanyEventToolbarAction;
}
